import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src3077383669/src/node_modules/next/dist/client/app-dir/link.js");
